<template>
  <v-container fluid>
    <v-layout data-app wrap>
      <!-- TOP NAV BAR -->
      <NavBarHome></NavBarHome>
			<v-flex xs12>
			<br/>
			<br/>
       <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
      <v-avatar slot="icon" color="deep-orange accent-4" size="40">
        <v-icon color="white">
          people_alt
        </v-icon>
      </v-avatar>
      You are viewing the survey of <strong>{{officeDescription}}</strong>.
      <template v-slot:actions>
        <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
      </template>
    	</v-banner>
  	</v-flex>
      <v-container fluid py-5 class="bg-light-blue admin-page">
        <!-- <h2>Contact Information for: {{this.officeName}}</h2> -->
        <h1>
          Update Contact Information
        </h1>

        <div v-if="this.showVerifyMessage()">
          <v-icon medium>info</v-icon>&nbsp;Please verify/update the information below and click &ldquo;Save&rdquo; so that our records are correct.
        </div>

        <!-- Page Form -->
        <v-form v-model="isFormValid" ref="form" id="adminForm">
          <v-layout wrap class="page-body column">
            <!-- SECTION 1 -->
            <v-container class="section">
              <h2 class="form-section-header">Primary Point of Contact</h2>
              <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="primary.nameFirst"
                      class="form-field"
                      required
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="primary.nameLast"
                      class="form-field"
                      required
                    />
                    <v-text-field label="Title" v-model="primary.title" class="form-field" />
                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="primary.phone"
                          class="form-field"
                          :rules="rules.phone"
                          required
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="primary.phoneExt"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>

                  </v-flex>
                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="primary.email"
                      class="form-field"
                      :rules="rules.email"
                      required
                    />
                    <v-text-field
                      label="Street Address 1"
                      v-model="primary.streetAddress1"
                      class="form-field"
                    />
                    <v-text-field
                      label="Street Address 2"
                      v-model="primary.streetAddress2"
                      class="form-field"
                    />
                    <v-text-field label="City" v-model="primary.city" class="form-field" />
                    <v-row class="mx-0">
                      <v-flex xs7 class="pr-2">
                        <v-text-field label="State" v-model="primary.state" class="form-field" />
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field label="Zip" v-model="primary.zip" class="form-field" />
                      </v-flex>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-container>
              <!-- </section> -->
            </v-container>

            <!-- SECTION 2 -->
            <v-container class="section">
              <h2 class="form-section-header">Supervisor Information</h2>
              <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="supervisor.nameFirst"
                      class="form-field"
                      required
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="supervisor.nameLast"
                      class="form-field"
                      required
                    />
                    <v-text-field label="Title" v-model="supervisor.title" class="form-field" />
                  </v-flex>
                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="supervisor.email"
                      class="form-field"
                      :rules="rules.email"
                      required
                    />

                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="supervisor.phone"
                          class="form-field"
                          :rules="rules.phone"
                          required
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="supervisor.phoneExt"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
            <!-- SECTION 3 -->
            <v-container class="section">
              <h2 class="form-section-header">Alternate Contact Information (#1 Optional)</h2>
              <div>
                <p class="body-1">
                  Note: If you enter an Alternate Contact, you need to fill in the First Name, Last Name, and E-mail fields. You can send login information to alternate contacts.
                </p>
              </div>
              <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="alternate.nameFirst"
                      class="form-field"
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="alternate.nameLast"
                      class="form-field"
                    />
                    <v-text-field label="Title" v-model="alternate.title" class="form-field" />
                  </v-flex>

                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="alternate.email"
                      class="form-field"
                    />

                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="alternate.phone"
                          class="form-field"
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="alternate.phoneExt"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>

                  </v-flex>
                </v-layout>
              </v-container>
              <v-container class="section">
              <h2 class="form-section-header">Alternate Contact Information (#2 Optional)</h2>
               <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="alternate.nameFirst2"
                      class="form-field"
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="alternate.nameLast2"
                      class="form-field"
                    />
                    <v-text-field label="Title" v-model="alternate.title2" class="form-field" />
                  </v-flex>

                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="alternate.email2"
                      class="form-field"
                    />

                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="alternate.phone2"
                          class="form-field"
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="alternate.phoneExt2"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>

                  </v-flex>
                </v-layout>
              </v-container>
              </v-container>
              <v-container class="section">
              <h2 class="form-section-header">Alternate Contact Information (#3 Optional)</h2>
               <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="alternate.nameFirst3"
                      class="form-field"
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="alternate.nameLast3"
                      class="form-field"
                    />
                    <v-text-field label="Title" v-model="alternate.title3" class="form-field" />
                  </v-flex>

                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="alternate.email3"
                      class="form-field"
                    />

                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="alternate.phone3"
                          class="form-field"
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="alternate.phoneExt3"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>

                  </v-flex>
                </v-layout>
              </v-container>
              </v-container>
              <v-container class="section">
              <h2 class="form-section-header">Alternate Contact Information (#4 Optional)</h2>
               <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="alternate.nameFirst4"
                      class="form-field"
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="alternate.nameLast4"
                      class="form-field"
                    />
                    <v-text-field label="Title" v-model="alternate.title4" class="form-field" />
                  </v-flex>

                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="alternate.email4"
                      class="form-field"
                    />

                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="alternate.phone4"
                          class="form-field"
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="alternate.phoneExt4"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>

                  </v-flex>
                </v-layout>
              </v-container>
              </v-container>
              <v-container class="section">
              <h2 class="form-section-header">Alternate Contact Information (#5 Optional)</h2>
               <v-container row class="sectionBody">
                <v-layout>
                  <v-flex column xs12 md6 px-4>
                    <v-text-field
                      label="First Name"
                      v-model="alternate.nameFirst5"
                      class="form-field"
                    />
                    <v-text-field
                      label="Last Name"
                      v-model="alternate.nameLast5"
                      class="form-field"
                    />
                    <v-text-field label="Title" v-model="alternate.title5" class="form-field" />
                  </v-flex>

                  <v-flex xs12 md6 px-4>
                    <v-text-field
                      label="E-mail"
                      v-model="alternate.email5"
                      class="form-field"
                    />

                    <v-row class="mx-0">
                      <v-flex xs8 class="pr-2">
                        <v-text-field
                          label="Phone"
                          v-model="alternate.phone5"
                          class="form-field"
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Phone Ext"
                          v-model="alternate.phoneExt5"
                          class="form-field"
                        />
                      </v-flex>
                    </v-row>

                  </v-flex>
                </v-layout>
              </v-container>
              </v-container>
            </v-container>
            <v-flex xs12>
                <div class="content-detail">{{lastSaved}}
                </div>
                <br/>
            </v-flex>
            <v-flex>
              <v-btn
                normal
                :loading="isLoading"
                class="form-button"
                @click="onSubmit"
              >Save Contact Info</v-btn>
              <v-btn normal :loading="isLoading" class="form-button" @click="onCancel">Home/Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-layout>
    <Footer></Footer>
  </v-container>
</template>
</template>

<script>
// TODO: Not sure how many of these imports are needed (besiderouter,  NavBarHome and footer)
import Vue from "vue";
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { officeManagementService } from "@/services/officeManagementService.js";
import { CONSTANTS } from "../common/constants";
import router from "@/router";
import { NavBarHome } from "@/components/NavBarHome.vue";
import { footer } from "@/components/Footer.vue";


export default {
  name: "OfficeContact",
  props: {
    lastSaved:String,
    isSuccess:Boolean
  },
  data() {
    return {
			impersonation: false,
			officeDescription: '',
    	officeId:'',
      isFormValid:true,
      isLoading: false,
      rules: {
        email: [v => /.+@.+\..+/.test(v) || "Must be a valid E-mail address"],
        phone: [
          v =>
            /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(v) ||
            "Must be a valid phone number"
        ]
      },
      primary: {
        nameFirst: null,
        nameLast: null,
        nameMiddleInitial: null,
        title: null,
        phone: null,
        phoneExt: null,
        fax: null,
        email: null,
        streetAddress1: null,
        streetAddress2: null,
        city: null,
        state: null,
        zip: null
      },
      alternate: {
        namefirst: null,
        nameLast: null,
        nameMiddleInitial: null,
        title: null,
        phone: null,
        phoneExt: null,
        fax: null,
        email: null,
        sendLogin: null,
        message: null
      },
      supervisor: {
        nameFirst: null,
        nameLast: null,
        title: null,
        phone: null,
        phoneExt: null,
        email: null
      },
      form: {
        nameFirst:null,
        nameLast:null,
        title: null,
        phone: null,
        phoneExt: null,
        email: null,
        streetAddress1: null,
        streetAddress2: null,
        city: null,
        state: null,
        zip: null,
        altNameFirst: null,
        altNameLast: null,
        altNameMiddleInitial: null,
        altTitle: null,
        altPhone: null,
        altPhoneExt: null,
        altEmail: null,
        supNameFirst: null,
        supNameLast: null,
        supTitle: null,
        supPhone: null,
        supPhoneExt: null,
        supEmail: null,
        volume: null,
        altNameFirst2: null,
        altNameLast2: null,
        altNameMiddleInitial2: null,
        altTitle2: null,
        altPhone2: null,
        altPhoneExt2: null,
        altEmail2: null,
        altNameFirst3: null,
        altNameLast3: null,
        altNameMiddleInitial3: null,
        altTitle3: null,
        altPhone3: null,
        altPhoneExt3: null,
        altEmail3: null,
        altNameFirst4: null,
        altNameLast4: null,
        altNameMiddleInitial4: null,
        altTitle4: null,
        altPhone4: null,
        altPhoneExt4: null,
        altEmail4: null,
        altNameFirst5: null,
        altNameLast5: null,
        altNameMiddleInitial5: null,
        altTitle5: null,
        altPhone5: null,
        altPhoneExt5: null,
        altEmail5: null,
      }
    };

  },
  watch: {

  },
  /*Added by Pansa*/
  mounted () {
    	this.isFormValid=true;
      const me = this;
			const claims = authTokenService.getClaims();
			if (claims.userName === "Admin")
			{
					const activeId = authTokenService.getActiveSurveyId();
					claims.surveyId = activeId;
					me.impersonation = true;
					me.isNotUnderAdmin="isDisabled";
					officeManagementService.getOfficeBySurveyId(activeId).then(function (response) {
							if (response && response.data) {
								me.officeDescription = response.data.description;
								me.officeId = response.data.id;
							}
					});
			}
      const currentVolume = authTokenService.getCurrentVolume();
      officeManagementService.getUserContactDetails(localStorage.getItem('userName'), currentVolume).then(function (response){
			if (response && response.data) {
        //primary
        me.primary.nameFirst = response.data.nameFirst;
        me.primary.nameLast = response.data.nameLast;
        me.primary.title = response.data.title;
        me.primary.phone = response.data.phone;
        me.primary.phoneExt = response.data.phoneExt;
        me.primary.fax = response.data.fax;
        me.primary.email = response.data.email;
        me.primary.streetAddress1 = response.data.streetAddress1;
        me.primary.streetAddress2 = response.data.streetAddress2;
        me.primary.city = response.data.city;
        me.primary.state = response.data.state;
        me.primary.zip = response.data.zip;
        //Alternate
        me.alternate.nameFirst = response.data.altNameFirst;
        me.alternate.nameLast = response.data.altNameLast;
        me.alternate.nameMiddleInitial = response.data.altNameMiddleInitial;
        me.alternate.title = response.data.altTitle;
        me.alternate.phone = response.data.altPhone;
        me.alternate.phoneExt = response.data.altPhoneExt;
        me.alternate.email = response.data.altEmail;
        //supervisor
        me.supervisor.nameFirst = response.data.supNameFirst;
        me.supervisor.nameLast = response.data.supNameLast;
        me.supervisor.title = response.data.supTitle;
        me.supervisor.phone = response.data.supPhone;
        me.supervisor.phoneExt = response.data.supPhoneExt;
        me.supervisor.email = response.data.supEmail;
        //Alternate2
        me.alternate.nameFirst2 = response.data.altNameFirst2;
        me.alternate.nameLast2 = response.data.altNameLast2;
        me.alternate.nameMiddleInitial2 = response.data.altNameMiddleInitial2;
        me.alternate.title2 = response.data.altTitle2;
        me.alternate.phone2 = response.data.altPhone2;
        me.alternate.phoneExt2 = response.data.altPhoneExt2;
        me.alternate.email2 = response.data.altEmail2;
         //Alternate3
        me.alternate.nameFirst3 = response.data.altNameFirst3;
        me.alternate.nameLast3 = response.data.altNameLast3;
        me.alternate.nameMiddleInitial3 = response.data.altNameMiddleInitial3;
        me.alternate.title3 = response.data.altTitle3;
        me.alternate.phone3 = response.data.altPhone3;
        me.alternate.phoneExt3 = response.data.altPhoneExt3;
        me.alternate.email3 = response.data.altEmail3;
         //Alternate4
        me.alternate.nameFirst4 = response.data.altNameFirst4;
        me.alternate.nameLast4 = response.data.altNameLast4;
        me.alternate.nameMiddleInitial4 = response.data.altNameMiddleInitial4;
        me.alternate.title4 = response.data.altTitle4;
        me.alternate.phone4 = response.data.altPhone4;
        me.alternate.phoneExt4 = response.data.altPhoneExt4;
        me.alternate.email4 = response.data.altEmail4;
          //Alternate5
        me.alternate.nameFirst5 = response.data.altNameFirst5;
        me.alternate.nameLast5 = response.data.altNameLast5;
        me.alternate.nameMiddleInitial5 = response.data.altNameMiddleInitial5;
        me.alternate.title5 = response.data.altTitle5;
        me.alternate.phone5 = response.data.altPhone5;
        me.alternate.phoneExt5 = response.data.altPhoneExt5;
        me.alternate.email5 = response.data.altEmail5;
      }
		})
		.catch(function (e) {
			console.log(e);
			console.log('Error loading Office Contact Information');
			throw e;
    });
  },
  methods: {
		exit () {
      router.push({ name: 'admin.stats' });
    },
    onSubmit() {
      this.isFormValid =true;
      if (this.isFormValid) {
        //this.isFormValid=false;
        //this.$data.isLoading = true;
        //Primary
        this.form.nameFirst=this.$data.primary.nameFirst;
        this.form.nameLast=this.$data.primary.nameLast;
        this.form.title=this.$data.primary.title;
        this.form.phone=this.$data.primary.phone;
        this.form.phoneExt=this.$data.primary.phoneExt;
        this.form.email=this.$data.primary.email;
        this.form.streetAddress1=this.$data.primary.streetAddress1;
        this.form.streetAddress2=this.$data.primary.streetAddress2;
        this.form.city=this.$data.primary.city;
        this.form.state=this.$data.primary.state;
        this.form.zip=this.$data.primary.zip;
        //alternate
        this.form.altNameFirst=this.$data.alternate.nameFirst;
        this.form.altNameLast=this.$data.alternate.nameLast;
        this.form.altTitle=this.$data.alternate.title;
        this.form.altPhone=this.$data.alternate.phone;
        this.form.altPhoneExt=this.$data.alternate.phoneExt;
        this.form.altEmail=this.$data.alternate.email;
        //supervisor
        this.form.supNameFirst=this.$data.supervisor.nameFirst;
        this.form.supNameLast=this.$data.supervisor.nameLast;
        this.form.supTitle=this.$data.supervisor.title;
        this.form.supPhone=this.$data.supervisor.phone;
        this.form.supPhoneExt=this.$data.supervisor.phoneExt;
        this.form.supEmail=this.$data.supervisor.email;
        this.form.volume = authTokenService.getCurrentVolume();
        //alternate2
        this.form.altNameFirst2=this.$data.alternate.nameFirst2;
        this.form.altNameLast2=this.$data.alternate.nameLast2;
        this.form.altTitle2=this.$data.alternate.title2;
        this.form.altPhone2=this.$data.alternate.phone2;
        this.form.altPhoneExt2=this.$data.alternate.phoneExt2;
        this.form.altEmail2=this.$data.alternate.email2;
         //alternate3
        this.form.altNameFirst3=this.$data.alternate.nameFirst3;
        this.form.altNameLast3=this.$data.alternate.nameLast3;
        this.form.altTitle3=this.$data.alternate.title3;
        this.form.altPhone3=this.$data.alternate.phone3;
        this.form.altPhoneExt3=this.$data.alternate.phoneExt3;
        this.form.altEmail3=this.$data.alternate.email3;
         //alternate4
        this.form.altNameFirst4=this.$data.alternate.nameFirst4;
        this.form.altNameLast4=this.$data.alternate.nameLast4;
        this.form.altTitle4=this.$data.alternate.title4;
        this.form.altPhone4=this.$data.alternate.phone4;
        this.form.altPhoneExt4=this.$data.alternate.phoneExt4;
        this.form.altEmail4=this.$data.alternate.email4;
        //alternate5
        this.form.altNameFirst5=this.$data.alternate.nameFirst5;
        this.form.altNameLast5=this.$data.alternate.nameLast5;
        this.form.altTitle5=this.$data.alternate.title5;
        this.form.altPhone5=this.$data.alternate.phone5;
        this.form.altPhoneExt5=this.$data.alternate.phoneExt5;
        this.form.altEmail5=this.$data.alternate.email5;


        officeManagementService.saveOfficeContact(localStorage.getItem('userName'),this.form).then((response)=> {
             // 204 - Success No Content
              this.isFormValid = true;
              let currentDatetime = new Date();
              this.lastSaved = 'Saved successfully!! at ' + currentDatetime;
					})
					.catch(function (e) {
             this.lastSaved = 'Failed to Save, exception: '+ e;
   					console.error(e);
						throw e;
					});

      }
    },
    onCancel() {
      // Return to landing page. There will be variation on this dependening where user came from.
      router.push({ name: "landing" });
    },
    /**
     * Returns true if the "verify" text should be shown. This is based on the incoming page.
     */
    showVerifyMessage() {
      // TODO If coming from landing page return false
      return true;
    },
    logout() {
      authService.logout();
    }
  },
  computed: {
    officeName: function() {
      return "Office name value";
    }
  }
};
</script>

<style>
.section {
  margin: 15px;
  border: 1px solid dimgray;
  border-top: 5px solid dimgray;
  padding: 15px;
  background-color: #ececec;
}

.sectionBody {
  justify-content: center;
  margin: 3px;
}

.sectionBody .v-text-field {
  padding-top: 0px;
  margin-top: 3px;
}

.sectionBody .v-text-field .v-label {
  padding-left: 10px;
}

.form-field input {
  text-align: left;
  background-color: white;
  padding-left: 10px !important;
}

input:required {
  border-left: 3px solid darkred !important;
}

.form-section-header {
  /* color: #25589b; */
  /* font-weight: bold; */
  /* font-size: 14pt; */
  margin-bottom: 10px;
  text-align: left;
  /* font-family: Georgia, Times, Times New Roman, Serif; */
  margin: 12px 15px;
}
.form-button {
  min-width: 100px;
}
.v-icon.v-icon {
  vertical-align: bottom !important;
}

.v-input--switch .v-input__control > .v-input__slot label {
  margin: 0;
}

.v-btn {
  margin-left: 15px;
}

/* overrides of global styles for this page */
#adminForm .v-input--selection-controls__input {
  margin-right: 5px !important;
}

.v-input--switch .v-input__control > .v-input__slot {
  border: none !important;
  margin-bottom: 0 !important;
}
</style>
